import { useMemo } from "react";
import moment from "moment-timezone";
import { useDateFilters } from "../../../hooks/useDateFilters";
import { usePreferences } from "../../../../Settings/Configuration/hooks/usePreferences";
import { enumerateDaysBetweenDates } from "../../../ManagerView/Table/useColumns";

export const useDateAvailabilityMap = ({ user, payGroupItems, retroAdjustments }) => {
    const { from, to } = useDateFilters();
    const payGroup = user?.payGroup;
    const hideRetroAdjustment = usePreferences("timeSheetGeneral.hideRetroAdjustment");

    return useMemo(() => {
        if (!payGroupItems || !payGroup) {
            return {};
        }
        const dates = enumerateDaysBetweenDates(moment(from), moment(to));

        const currentPayGroupDates = enumerateDaysBetweenDates(
            moment.parseZone(payGroup.periodStartDate).utcOffset(moment().utcOffset()),
            moment.parseZone(payGroup.periodEndDate).utcOffset(moment().utcOffset()),
        );
        const base = currentPayGroupDates.reduce((total, date) => {
            total[date] = false;
            return total;
        }, {});

        return dates.reduce((total, date) => {
            const item = payGroupItems.find((item) => {
                const start = moment.parseZone(item.periodStartDate);
                const end = moment.parseZone(item.periodEndDate);
                const _date = moment(date, "YYYY-MM-DD").utcOffset(start.utcOffset(), true);
                return _date.isSameOrAfter(start, "date")
                    && _date.isSameOrBefore(end, "date");
            });

            const retroItem = !hideRetroAdjustment ? retroAdjustments?.find((value) => {
                return value.status === "pending" &&
                    value.payGroup === payGroup?.id &&
                    moment.parseZone(value.startDate).isSame(moment.parseZone(item?.periodStartDate), "date") &&
                    moment.parseZone(value.endDate).isSame(moment.parseZone(item?.periodEndDate), "date")
            }) : undefined;

            if (item || retroItem) {
                total[date] = (retroItem || item)?.status
                    ? (retroItem || item)?.status === "locked"
                    : false
            } else {
                // total[date] = moment(date, "YYYY-MM-DD")
                //     .isSameOrAfter(moment.parseZone(payGroup.periodStartDate).startOf("day"));
                total[date] = false;
            }
            return total;
        }, base);
    }, [payGroupItems, payGroup, from, to, retroAdjustments, hideRetroAdjustment]);
}
